import script from "./CounterpartiesDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterpartiesDefault.vue?vue&type=script&setup=true&lang=js"

import "./CounterpartiesDefault.vue?vue&type=style&index=0&id=3d048ce6&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d048ce6"]])

export default __exports__